import React, { Component } from 'react'
import { connect, ConnectedProps } from 'react-redux'
import { produce } from 'immer'
import { round } from 'lodash'
import { RootState } from '../../store'
import {
  decrementZoom,
  incrementZoom
} from '../../views/LabelBuilder/LabelBuilder.slice'
import Icon from '../Icon'
import Badge from './Badge'

interface Props {}

type CombinedProps = Props & ConnectedProps<typeof connector>

class ZoomProperty extends Component<CombinedProps> {
  get percentage () {
    const percentage = round(this.props.zoom * 100)
    return (
      <span className='text-xxs'>{`${percentage}%`}</span>
    )
  }

  render () {
    return (
      <Badge>
        <Icon
          name='zoom-out'
          size="extraSmall"
          color="dark"
          onClick={this.props.decrementZoom} />
        {this.percentage}
        <Icon
          name='zoom-in'
          size="extraSmall"
          color="dark"
          onClick={this.props.incrementZoom} />
      </Badge>
    )
  }
}

function mapStateTopProps (state: RootState, props: Props) {
  const { labelBuilder } = produce(state, draft => draft)
  const { zoom } = labelBuilder.markup
  return { zoom }
}

const mapDispatchToProps = {
  decrementZoom,
  incrementZoom
}

const connector = connect(mapStateTopProps, mapDispatchToProps)
export default connector(ZoomProperty)
